import type { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { RETIREMENT_LOAN_DOMAINS } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementPortfolioItemKind } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementPortfolioItemKind = (
	domain: ClientPortfolioDomainEnum,
): RetirementPortfolioItemKind =>
	RETIREMENT_LOAN_DOMAINS.has(domain) ? "loan" : "saving";
